import { feedbackAudioUrl, isCorrectFeedback } from '../feedbackAudio';
import { setRoundAudioPlayback } from './pronunciationPlayback';

// Shared tour audio transport: authored Tomris URL, shared Audio, reviewed
// pronunciation speed, explicit failure and cancellation. No synthetic voice.
export function playRoundClip(round, audioRef, id) {
  let cancel = () => {};
  const done = new Promise((resolve, reject) => {
    const url = feedbackAudioUrl(id, round.audio?.[id]);
    if (!url) { reject(new Error('Onaylı Tomris ses kaydı bulunamadı.')); return; }
    const audio = audioRef.current || new Audio(url);
    audioRef.current = audio;
    audio.src = url; audio.preload = 'auto'; audio.muted = false;
    setRoundAudioPlayback(audio, round, id);
    let settled = false, timer;
    const clean = () => { clearTimeout(timer); audio.onended = null; audio.onerror = null; };
    const fail = error => { if (settled) return; settled = true; clean(); audio.pause(); reject(error); };
    cancel = () => fail(new Error('cancelled'));
    audio.onended = () => { if (!settled) { settled = true; clean(); resolve(); } };
    audio.onerror = () => fail(new Error('Tomris sesi çalınamadı. Dinle düğmesiyle tekrar deneyelim.'));
    timer = setTimeout(() => fail(new Error('Tomris sesi yüklenemedi. Dinle düğmesiyle tekrar deneyelim.')), isCorrectFeedback(id) ? 1500 : 30000);
    try { Promise.resolve(audio.play()).catch(fail); } catch (error) { fail(error); }
  });
  return { done, cancel: () => cancel() };
}
